<template>
  <div class="bs-launch">
    <div class="launch-box">
      <div class="launch-ico">⛶</div>
      <h2>月度数据驾驶舱 · 全屏播放入口</h2>
      <p class="launch-desc">
        点击下方按钮即可以<b>全屏无侧边栏</b>方式打开大屏，适合电视 / 一体机直接播放。<br />
        若需按区域、校区、收款账户筛选，请先到「<b>月度驾驶舱大屏</b>」页勾选后再打开。
      </p>

      <div class="launch-actions">
        <el-button type="primary" size="large" @click="openScreen">全屏打开大屏</el-button>
        <el-button size="large" @click="goPortal">先去筛选范围</el-button>
      </div>

      <div class="launch-url">
        <span class="url-label">直连地址（可设为电视浏览器首页 / 书签）：</span>
        <code>{{ screenUrl }}</code>
        <el-button size="small" @click="copyUrl">复制</el-button>
      </div>

      <el-table :data="tips" size="small" border class="tip-table">
        <el-table-column prop="k" label="场景" width="150" />
        <el-table-column prop="v" label="做法" />
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BattleScreenLaunch',
  data() {
    return {
      tips: [
        { k: '电视直接播放', v: '把直连地址设为电视浏览器首页，开机自动进入大屏（无需登录）' },
        { k: '只看某个城市', v: '在地址后加 ?prefix=南阳  →  标题显示「南阳 · 月度战报」' },
        { k: '预置筛选范围', v: '加 ?areaIds=629,631 或 ?flags=1,2 或 ?paymentIds=32,33' },
        { k: '指定月份', v: '加 ?month=2026-09；不传则默认当前月' },
        { k: '多参数组合', v: '用 & 连接，例如 ?flags=1&areaIds=629&month=2026-09' }
      ]
    };
  },
  computed: {
    screenUrl() {
      return `${window.location.origin}/battleScreen`;
    }
  },
  methods: {
    openScreen() {
      // 用 <a target=_blank> 保证以新标签全屏打开，不被路由 keep-alive 拦截
      const a = document.createElement('a');
      a.href = '/battleScreen';
      a.target = '_blank';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    goPortal() {
      this.$router.push('/battleScreenPortal');
    },
    async copyUrl() {
      const text = this.screenUrl;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.$message.success('已复制直连地址');
      } catch (e) {
        this.$message.warning('复制失败，请手动选择地址复制');
      }
    }
  }
};
</script>

<style scoped>
.bs-launch { padding: 10px 2px 40px; }

.launch-box {
  max-width: 900px;
  margin: 0 auto;
  padding: 30px 34px;
  border-radius: 12px;
  background: linear-gradient(150deg, #1e1b2e 0%, #2d2640 55%, #3a2f52 100%);
  color: #fff;
  box-shadow: 0 8px 26px rgba(30, 27, 46, .28);
}

.launch-ico { font-size: 38px; line-height: 1; margin-bottom: 10px; }
.launch-box h2 { margin: 0 0 14px; font-size: 21px; font-weight: 600; letter-spacing: .5px; }
.launch-desc {
  margin: 0 0 22px;
  font-size: 13px;
  line-height: 1.85;
  color: rgba(255, 255, 255, .8);
}
.launch-desc b { color: #d8b4fe; }

.launch-actions { display: flex; gap: 12px; margin-bottom: 24px; }

.launch-url {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .08);
  border: 1px solid rgba(255, 255, 255, .16);
  flex-wrap: wrap;
}
.url-label { font-size: 12.5px; color: rgba(255, 255, 255, .66); }
.launch-url code { font-size: 12.5px; color: #b9e0ff; word-break: break-all; }

.tip-table { background: #fff; border-radius: 8px; }
</style>
